<template>
  <b-modal
    id="first-connexion-modal"
    ref="modal"
    :cancel-title="$t('Continue')"
    :ok-title="$t('Welcome.update.password')"
    :title="$t('Welcome')"
    centered
    cancel-variant="primary"
    ok-variant="danger"
    @ok="goToChangePasswordModal">

    <p>{{ $t('Welcome.message') }}</p>

  </b-modal>
</template>

<script>
export default {
  name: 'first-connexion-modal',

  methods: {

    goToChangePasswordModal() {
      this.$bvModal.hide('first-connexion-modal');
      this.$nextTick(() => {
        this.$bvModal.show('change-password-modal');
      });
    },
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/user/FirstConnexionModal.vue